// @flow

import _ from 'lodash';

import {
  OTHER,
  RECURRING,
  FILL_COUNT_FIELD_NAME,
  FILL_QUANTITY_FIELD_NAME,
  OTHER_FILL_COUNT_FIELD_NAME,
  OTHER_FILL_QUANTITY_FIELD_NAME,
  OTHER_PRESCRIPTION_DURATION_FIELD_NAME,
  PRESCRIPTION_DURATION_FIELD_NAME,
} from 'client/constants/health/drug';

import MemberUtils from 'web-core/src/utils/member';

export type DrugDoseType = {
  id: number,
  drugId: number,
  gpi: string,
  maintenance: string,
  mony: string,
  ndc: string,
  otc: string,
  qty: string,
  route: string,
  strength: string,
};

export type DrugType = {
  brand: string,
  dose: DrugDoseType,
  doseForm: string,
  doseFormCode: string,
  freqs: Array<Object>,
  generic: string,
  genericId: number,
  id: number,
  product: string,
  qtyDivisible: boolean,
  relatedBrand: string | null,
};

export type MemberDrugInfoType = {
  brand: string,
  dose: DrugDoseType,
  doseForm: string,
  doseFormCode: string,
  durationDays: number,
  fillCount: number,
  fillQty: number,
  generic: string,
  genericId: number,
  id: number,
  product: string,
  qtyDivisible: boolean,
};

export type SessionMemberDrugType = {
  drug_json: MemberDrugInfoType,
  id: string,
  member_id: string,
};

export class Session_Member_Drug {
  drug_json: MemberDrugInfoType;
  id: string;
  member_id: string;
  constructor({ drug_json, member_id }: { drug_json: MemberDrugInfoType, member_id: string }) {
    this.drug_json = drug_json;
    this.member_id = member_id;
    this.id = MemberUtils.uuid();
  }
}

class DrugInfoModel {
  brand: string;
  dose: DrugDoseType;
  doseForm: string;
  doseFormCode: string;
  durationDays: number;
  fillCount: number;
  fillQty: number;
  generic: string;
  genericId: number;
  id: number;
  product: string;
  qtyDivisible: boolean;
  constructor({ dose, drug, formData }: { dose: DrugDoseType, drug: DrugType, formData: Object }) {
    this.id = drug.id;
    this.genericId = drug.genericId;
    this.brand = drug.brand;
    this.generic = drug.generic;
    this.product = drug.product;
    this.doseForm = drug.doseForm;
    this.qtyDivisible = drug.qtyDivisible;
    this.doseFormCode = drug.doseFormCode;
    this.dose = dose;
    this.fillQty = this.getFieldValue(
      formData,
      FILL_QUANTITY_FIELD_NAME,
      OTHER_FILL_QUANTITY_FIELD_NAME,
    );
    this.durationDays = this.getFieldValue(
      formData,
      PRESCRIPTION_DURATION_FIELD_NAME,
      OTHER_PRESCRIPTION_DURATION_FIELD_NAME,
    );
    this.fillCount = this.getFillCount(formData);
  }

  getFieldValue = (formData: Object, selectInputName: string, textInputName: string) => {
    const selectValue = _.get(formData, selectInputName);
    const textValue = _.get(formData, textInputName);
    return selectValue !== OTHER ? Number(selectValue) : Number(textValue);
  };

  getFillCount = (formData: Object) => {
    const durationDays = this.getFieldValue(
      formData,
      PRESCRIPTION_DURATION_FIELD_NAME,
      OTHER_PRESCRIPTION_DURATION_FIELD_NAME,
    );

    if (formData[FILL_COUNT_FIELD_NAME] === RECURRING) {
      return Math.floor(365 / (durationDays || 30));
    }
    return this.getFieldValue(formData, FILL_COUNT_FIELD_NAME, OTHER_FILL_COUNT_FIELD_NAME);
  };
}

export default DrugInfoModel;
